import { ValueOf, AdManagerAdCampaignEntity } from 'sl-api-connector/types';

import types from './types';
import actionCreators from './actions';

type Action = ValueOf<{ [K in keyof typeof actionCreators]: ReturnType<(typeof actionCreators)[K]> }>;

export default (state = [] as AdManagerAdCampaignEntity[], action: Action) => {
  switch (action.type) {
    case types.RECEIVE_ADGROUPS:
      return action.adGroups;
    case types.CLEAR_ADGROUPS:
      return [];
    default:
      return state;
  }
};
